import { render, staticRenderFns } from "./BulkShipmentDestinationEditForm.vue?vue&type=template&id=a639b0a0&scoped=true&"
import script from "./BulkShipmentDestinationEditForm.vue?vue&type=script&lang=ts&"
export * from "./BulkShipmentDestinationEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./BulkShipmentDestinationEditForm.vue?vue&type=style&index=0&id=a639b0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a639b0a0",
  null
  
)

export default component.exports